import React, { FC } from "react";
import DocumentSection from "components/front/layout/DocumentSection";

export type Props = {};
const PrivacySection: FC<Props> = () => {
  return (
    <DocumentSection>
      <section>
        <p>アニメファンド株式会社は、クラウドファンディングプラットフォームのサービス事業を提供しています。</p>
      </section>
      <section>
        <h4>個人情報収集について</h4>
        <p>
          個人情報とは、個人に関する情報であり、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別することができるもの（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含む。）を指します。
          <br />
          当社は当社サービスにおいて、個人情報保護に関する法令およびその他の規範を遵守し、自主的なルールおよび体制を確立し、次の事項を含むプライバシーポリシーを定め、これを実施し、かつ、維持することを宣言いたします。
        </p>
      </section>
      <section>
        <h4>個人情報の利用について</h4>
        <p>当社は、収集した個人情報を以下の目的で利用することができるものとします。</p>
        <ul>
          <li>1. 本人確認、認証サービスのため</li>
          <li>2. アフターサービス、お問い合わせ、苦情対応のため</li>
          <li>3. 当社へのお問い合わせ、当社サービスの運営上必要な事項の通知（電子メールによるものを含むものとします。）</li>
          <li>4. ユーザーが投稿した情報の掲載</li>
          <li>5. システムの維持、不具合対応のため</li>
          <li>6. 当社サービスの改善や新サービスの開発等に役立てるため</li>
          <li>7. 登録ユーザーの反社会的勢力の該当性を判断するため</li>
          <li>8. キャンペーン・懸賞企画、アンケートの実施のため</li>
          <li>9. メールマガジンの送信のため</li>
          <li>10. ダイレクトメールの送付のため</li>
          <li>
            11.
            当社または第三者のウェブサイト、Webメディア、SNSサービス、プレスリリース配信サービス、本、雑誌その他メディア上にユーザーの属性にあった広告を表示、掲載または配信するため
          </li>
          <li>12. マーケティングデータの調査・分析、当社における新たなサービス開発のため</li>
          <li>13. 当社および業務提携企業に提供する統計資料作成のため</li>
          <li>14．当社が加入する賠償責任保険等の保険金請求をするため</li>
          <li>15．その他、上記利用目的に付随する目的のため</li>
        </ul>
      </section>
      <section>
        <h4>個人情報の第三者への提供</h4>
        <p>当社は、以下に定める場合には、個人情報を第三者に提供することができるものとします。</p>
        <ul>
          <li>1. 本人の同意がある場合</li>
          <li>2. 裁判所、検察庁、警察、税務署、弁護士会またはこれらに準じた権限を持つ機関から、個人情報の開示を求められた場合</li>
          <li>3. 保険金請求のために保険会社に開示する場合</li>
          <li>4. 利用目的の達成に必要な範囲内において当社が行う業務の全部または一部を第三者に委託する場合</li>
          <li>5. 当社に対して秘密保持義務を負う者に対して開示する場合</li>
          <li>6. 当社の権利行使に必要な場合</li>
          <li>7. 合併、営業譲渡その他の事由による事業の承継の際に、事業を承継する者に対して開示する場合</li>
          <li>8. 個人情報保護法その他の法令により認められた場合</li>
        </ul>
      </section>
      <section>
        <h4>個人情報の提供の同意</h4>
        <p>
          当社は、法令で認められる場合またはお客様の同意をいただいた場合には第三者に対して個人情報を提供いたします。以下の場合においては、当社は第三者に対して、必要な範囲で個人情報を提供させていただきますので、あらかじめご了承ください。
        </p>
        <ul>
          <li>1. 保険会社に対する保険金請求のために必要となるとき、当該保険会社に開示する場合</li>
          <li>
            2.
            第三者のウェブサイト、Webメディア、SNSサービス、プレスリリース配信サービス、本、雑誌その他メディア上にユーザーの属性にあった広告を表示、掲載または配信するために、当該第三者に提供する場合
          </li>
        </ul>
        <p>
          なお、当社は、お客様へのサービスの提供等のため必要がある場合には、委託先に対する必要かつ適切な監督を行った上で、個人情報の取り扱いを第三者に委託することがあります。
        </p>
      </section>
      <section>
        <h4>個人情報の開示</h4>
        <p>
          当社は、ご本人から、個人情報の開示を求められたときは、ご本人に対し、遅滞なく開示します。ただし、開示することにより次のいずれかに該当する場合は、その全部または一部を開示しないこともあり、開示しない決定をした場合には、その旨を遅滞なく通知します。
        </p>
        <ul>
          <li>1. ご本人または第三者の生命、身体、財産その他の権利利益を害するおそれがある場合</li>
          <li>2. 当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合</li>
          <li>3. 他の法令に違反することとなる場合</li>
        </ul>
      </section>
      <section>
        <h4>個人情報の訂正等</h4>
        <p>
          当社は、ユーザーご本人より当該本人の個人情報の訂正、追加、削除、利用の停止または消去を求められた場合には、ユーザーご本人であることを確認させていただいた上で合理的な期間内に対応いたします。
        </p>
      </section>
      <section>
        <h4>プライバシーポリシーの更新について</h4>
        <p>
          当社は、個人情報保護を図るため、法令等の変更や必要に応じて、プライバシーポリシーを改訂することがあります。その際は、最新のプライバシーポリシーを当社サービスのサイト内に掲載いたします。
        </p>
      </section>
      <section>
        <h4>免責</h4>
        <p>
          当社では、お客様のID及びパスワードの管理については関与いたしません。お客様の不注意によりID及びパスワードが第三者に利用された場合は、ご登録いただいている個人情報を閲覧される可能性がございますので、ご利用にあたっては、使用および管理について責任を負うと共に、使用上の過誤または第三者による不正使用等について十分注意をして下さい。
        </p>
      </section>
    </DocumentSection>
  );
};
export default PrivacySection;
